export enum OrdersTabParentState {
  CATALOG = 'Management_Catalog',
  MATERIAL = 'Management_Material',
  NULL = '',
}
